import { render, staticRenderFns } from "./layout-h5.vue?vue&type=template&id=383d9b74&scoped=true&"
import script from "./layout-h5.vue?vue&type=script&lang=js&"
export * from "./layout-h5.vue?vue&type=script&lang=js&"
import style0 from "./layout-h5.vue?vue&type=style&index=0&id=383d9b74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d9b74",
  null
  
)

export default component.exports